<style scoped>
.children-wrapper {
  margin-left: 16px;
}
.content-wrapper {
  margin-left: 8px;
  margin-right: 8px;
}
</style>

<template>
  <div>
    <mu-divider />
    <div v-if="object.type === 'media'">
      <div v-if="completionFetched && userId" class="float-right">
        <loading-progress
          :progress="progress"
          shape="line"
          size="100"
          width="100"
          height="10"
          />
        <div class="progress-text">{{ stringCompleted }}%</div>
      </div>
      <div class="float-right" v-if="userId === null && graphMode">
        <mu-menu cover>
          <mu-button 
            color="primary" 
            icon
            >
            <mu-icon value="bar_chart" />
          </mu-button>
          <mu-list slot="content">
            <mu-list-item button 
              @click="onOpenGraph(item.value)" 
              v-for="item in graphOptions"
              >
              <mu-list-item-title>{{item.text}}</mu-list-item-title>
            </mu-list-item>
          </mu-list>
        </mu-menu>
      </div>
      <div class="item-title">
        {{object.obj.name}}
      </div>
      <div class="content-wrapper">
        <small v-if="object.obj.description">
          {{object.obj.description}}
        </small>
      </div>
    </div>
    <div v-else-if="object.type === 'playlist'">
      <mu-button
        @click="toggle = !toggle"
        color="primary"
        flat
        small
        class="float-right"
        >
        {{$t('playlist.childrenCount', { num: object.children.length, s: object.children.length >= 2 ? 's' : '' })}}
        <mu-icon :value="toggle ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"/>
      </mu-button>
      <div class="item-title">
        {{object.obj.name}}
      </div>
      <div class="content-wrapper">
        <small v-if="object.obj.description">
          {{object.obj.description}}
        </small>
      </div>
      <div class="clearfix" />
      <div class="children-wrapper" v-if="toggle">
        <AnalyticsItem 
          v-for="child in object.children"
          :object="child"
          :userId="userId"
          :graphMode="graphMode"
          />
      </div>
    </div>
    <mu-dialog :open.sync="graphPanelOpen" width="50%" scrollable>
      <component
        :is="graphComponentName === '' ? 'div' : graphComponentName"
        :media="object.obj"
        @close="onClose"
        />
    </mu-dialog>
  </div>
</template>

<script>

import AnalyticsItem from '@/components/Analytics/Item/Main.vue'

import AnalyticsCompletion from '@/components/Analytics/Completion/Main.vue'
import AnalyticsReaction from '@/components/Analytics/Reaction/Main.vue'
import AnalyticsDuration from '@/components/Analytics/Duration/Main.vue'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import axios from "axios";

export default {
  name: "AnalyticsItem",
  props: {
    object: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      default: null
    },
    graphMode: {
      type: Boolean,
      default: false
    },
  },
  components: {
    AnalyticsItem,
    AnalyticsCompletion,
    AnalyticsReaction,
    AnalyticsDuration,
  },
  watch: {
    userId(newValue) {
      if(newValue && !this.graphMode && this.object.type === 'media') {
        this.fetchCompletion();
      }
    },
  },
  data: function() {
    return {
      toggle: true,
      completion: {},
      completionFetched: false,
      
      graphPanelOpen: false,
      graphComponentName: '',
    }
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  mounted() {
    if(this.userId && !this.graphMode && this.object.type === 'media') {
      this.fetchCompletion();
    } 
  },
  computed: {
    graphOptions() {
      var result = [
        { value: 'AnalyticsCompletion', text: this.$t('AnalyticsItem.completion') },
      ];
      if(this.object.obj.type === 'video' || this.object.obj.type === 'youtube' || this.object.obj.type === 'mp4link') {
        result.push({ value: 'AnalyticsReaction', text: this.$t('AnalyticsItem.reaction') });
        result.push({ value: 'AnalyticsDuration', text: this.$t('AnalyticsItem.duration') });
      }
      return result;
    },
    progress() {
      return this.completion.completion;
    },
    progressPercentage() {
      return Math.round(this.progress * 100);
    },
    questionProgress() {
      return this.completion.question_correct / this.completion.question_total;
    },
    questionPercentage() {
      return Math.round(this.questionProgress * 100);
    },
    
    stringCompleted() {
      if(this.object.obj.type === 'video' || this.object.obj.type === 'youtube' || this.object.obj.type === 'mp4link') {
        return this.$t('AnalyticsItem.completed.watched') + ' ' + this.progressPercentage;
      } else {
        return this.$t('AnalyticsItem.completed.finished') + ' ' + this.progressPercentage;
      }
    },
  },
  methods: {
    onOpenGraph(value) {
      this.graphComponentName = value;
      this.graphPanelOpen = true;
    },
    onClose() {
      this.graphComponentName = '';
      this.graphPanelOpen = false;
    },
    
    fetchCompletion() {
      this.completionFetched = false;
      axios.get(this.$store.getters.urlApi + "media/" + this.object.obj._id + '/completion/' + this.userId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.completion = response.data.data
        this.completionFetched = true;
      });
    },
  },
};
</script>
